import React from 'react'
import TermListEntry from './TermListEntry';
import TermList from './TermList';
import FriendButtonList from './FriendButtonList';
import { friendList,clerksElement } from './myFunctions';
export default function Service({oym,committee,dropBreadcrumb,authenticated,noTerm,noOffice}) {
    let committeeObject =oym.objectRef(committee);
    console.log("service:",committeeObject);
    console.log("service:",committeeObject.members);
    let thoseServing = null;
    if (committeeObject.members==undefined){
        if (committeeObject.tenuresOfThoseServing==undefined){
            // do nothing.  thoseServing stays null
        } else{
            thoseServing=committeeObject.tenuresOfThoseServing[1];
        }
    } else {
        thoseServing=committeeObject.members[1];
    }
    const whiteSpaceStyle = {
        'white-space': 'pre-line',
      };
    let description = (committeeObject.description!==null) ? committeeObject.description : "No discription available";
    let tableHeadings =(<tr><th>Term</th><th>Member</th><th>Meeting</th></tr>);
    if (noTerm){
             tableHeadings =(<tr><th>Member</th><th>Meeting</th></tr>);      
    }
    let members = (<></>);
    if (thoseServing !== undefined&&thoseServing!==null){
        members = (
            <>
            <h2>Members</h2>
            <table>
                {tableHeadings}
            <TermList oym={oym} list={thoseServing} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} noTerm={noTerm}  noOffice={noOffice}/>
            </table>
            </>
        )
    }
    return (
        <div style={{whiteSpace: "pre-wrap"}} > 
            <h1>{committeeObject.name}</h1>
            {clerksElement(committeeObject,oym,dropBreadcrumb,authenticated)}
            <br/>
            {description}
            {members}
        </div>
    )
}
